<template lang="pug">
#modal-vetorial
    el-dialog(
        title='Importar Nota Fiscal',
        width='500px',
        top='5vh',
        :visible='show',
        :destroy-on-close='true',
        @close='closeDialog'
    )

        el-upload.upload-demo(
            action='#',
            drag,
            :file-list='fileList',
            :limit='1',
            :on-exceed='handleExceed',
            :auto-upload='false',
            :on-change='onLoadFile',
            :on-remove='onRemoveFile',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100 Arraste o arquivo aqui ou <em>clique para subir</em>

        .d-flex.flex-direction.justify-content-between.py-3
            BaseButton(slot='footer', size='mini', @click='closeDialog') Cancelar
            BaseButton(
                :loading='carregando'
                slot='footer',
                size='mini',
                type='primary',
                @click='carregarArquivo'
            ) Carregar
</template>

<script>
import axios from 'axios';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalInsercaoArquivoNotaDePesagem',

    components: {
        BaseButton
    },

    emits: ['sucessoUpload', 'closeModal'],

    props: {
        show: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            arquivoUpload: null,
            carregando: false,
            fileList: []
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('closeModal');
        },

        carregarArquivo() {
            if (!this.arquivoUpload) {
                this.$notify.error({
                    message: 'Arquivo de Nota de Pesagem é obrigatório'
                });
                return;
            }
            this.carregando = true;
            let url = process.env.VUE_APP_HTTP_PATH + '/rastreabilidade/nota-fiscal/inserir';
            let formData = new FormData();
            formData.append('file', this.arquivoUpload.raw);
            axios
                .post(url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    this.carregando = false;
                    if (response.status === 200) {
                        this.$notify.success({
                            message: response.data
                        });
                        this.closeDialog();
                        this.atualizarTabela();
                    } else {
                        this.$notify.error({
                            message: 'Ocorreu um erro ao inserir o arquivo'
                        });
                    }
                })
                .catch(error => {
                    this.carregando = false;
                    if (error.response.status === 409) {
                        this.$notify.error({
                            message: error.response.data
                        });
                    } else {
                        this.$notify.error({
                            message: error.response.data.message
                        });
                    }
                });
        },

        handleExceed() {
            this.$notify.warning(`O limite é de 1 arquivo!`);
        },

        atualizarTabela() {
            this.$emit('sucessoUpload');
        },

        async onLoadFile(file) {
            let extension = file.name.split('.').pop().toLowerCase();
            let reader = new FileReader();

            if (extension !== 'csv') {
                 this.$notify.error({ message: 'Tipo de arquivo não permitido.' });
                 this.onRemoveFile();
            } else {
                this.arquivoUpload = file;
                reader.readAsText(file.raw);
            }
        },

        onRemoveFile() {
            this.clearFields();
        },

        clearFields() {
            this.arquivoUpload = null;
        }
    }
};
</script>

<style lang="scss">
#modal-vetorial {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }
}
</style>
